import { registerWidget } from '../registry'
import { BlindnessBoardWidget } from './BlindnessBoardWidget'
import { IncidentsWidget } from './IncidentsWidget'
import { JourneysBoardWidget } from './JourneysBoardWidget'
import { KpiStripWidget } from './KpiStripWidget'
import { SecurityRollupWidget } from './SecurityRollupWidget'
import { TenantsWidget } from './TenantsWidget'

registerWidget('kpi-strip', KpiStripWidget)
registerWidget('journeys-board', JourneysBoardWidget)
registerWidget('active-incidents', IncidentsWidget)
registerWidget('security-rollup', SecurityRollupWidget)
registerWidget('tenant-movements', TenantsWidget)
registerWidget('data-blindness-board', BlindnessBoardWidget)
